// src/ui.js
// Peças visuais compartilhadas pelas telas de cadastro e pelo Dashboard,
// para todas seguirem o mesmo padrão (o mesmo da tela "Concluídas").
import React, { useEffect, useMemo, useRef, useState } from 'react';

// WhatsApp Web: link que abre DIRETO a conversa (sem a página intermediária do api.whatsapp.com / wa.me).
// Abre sempre na mesma aba "whatsapp", para não ficar abrindo várias abas do WhatsApp Web.
export const linkWhatsApp = (telefone, texto = '') => {
    const d = String(telefone || '').replace(/\D/g, '');
    if (!d) return '';
    const numero = d.startsWith('55') && d.length >= 12 ? d : `55${d}`;
    return `https://web.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(texto)}`;
};
export const abrirWhatsApp = (telefone, texto = '') => {
    const url = linkWhatsApp(telefone, texto);
    if (!url) return false;
    const aba = window.open(url, 'whatsapp');
    if (aba) { try { aba.opener = null; aba.focus(); } catch (e) { /* ignora */ } }
    return true;
};

export const normalizar = (s) => String(s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

export const inputCls = 'w-full h-9 border border-gray-300 rounded-md px-3 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:border-indigo-400 disabled:bg-gray-100';

// ---------- ícones ----------
export const Svg = ({ className = 'h-4 w-4', children }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
export const IconBusca = (p) => <Svg {...p}><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></Svg>;
export const IconMais = (p) => <Svg {...p}><path d="M12 5v14M5 12h14" /></Svg>;
export const IconLapis = (p) => <Svg {...p}><path d="M15.232 5.232l3.536 3.536M4 20h4L18.5 9.5a2.5 2.5 0 00-3.536-3.536L4.5 16.5 4 20z" /></Svg>;
export const IconLixo = (p) => <Svg {...p}><path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M4 7h16M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3" /></Svg>;
export const IconUsuario = (p) => <Svg {...p}><path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></Svg>;
export const IconUsuarios = (p) => <Svg {...p}><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></Svg>;
export const IconPredio = (p) => <Svg {...p}><path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></Svg>;
export const IconCubo = (p) => <Svg {...p}><path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" /></Svg>;
export const IconMaleta = (p) => <Svg {...p}><path d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></Svg>;
export const IconGrafico = (p) => <Svg {...p}><path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></Svg>;
export const IconTelefone = (p) => <Svg {...p}><path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></Svg>;
export const IconEmail = (p) => <Svg {...p}><path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></Svg>;

// ---------- cabeçalho de página ----------
const CORES_ICONE = {
    indigo: 'bg-indigo-100 text-indigo-700',
    blue: 'bg-blue-100 text-blue-700',
    green: 'bg-green-100 text-green-700',
    amber: 'bg-amber-100 text-amber-700',
    violet: 'bg-violet-100 text-violet-700',
};
export const PageHeader = ({ icon: Icon, cor = 'indigo', titulo, subtitulo, children }) => (
    <div className="flex flex-wrap items-end gap-3">
        <div className="mr-auto">
            <h2 className="text-2xl font-semibold text-gray-800 flex items-center gap-2">
                {Icon && <span className={`inline-flex items-center justify-center h-8 w-8 rounded-full ${CORES_ICONE[cor]}`}><Icon className="h-5 w-5" /></span>}
                {titulo}
            </h2>
            {subtitulo && <p className="text-sm text-gray-500 mt-0.5">{subtitulo}</p>}
        </div>
        {children}
    </div>
);

// ---------- cartão ----------
export const Card = ({ titulo, acao, children, className = '', semPadding }) => (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-200 ${className}`}>
        {(titulo || acao) && (
            <div className="flex flex-wrap items-center gap-2 px-4 py-3 border-b border-gray-100">
                {titulo && <h3 className="text-sm font-semibold text-gray-700 mr-auto">{titulo}</h3>}
                {acao}
            </div>
        )}
        <div className={semPadding ? '' : 'p-4'}>{children}</div>
    </div>
);

// ---------- campo com rótulo ----------
export const Campo = ({ rotulo, obrigatorio, ajuda, children, className = '' }) => (
    <label className={`block ${className}`}>
        <span className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
            {rotulo}{obrigatorio && <span className="text-red-500 ml-0.5">*</span>}
        </span>
        {children}
        {ajuda && <span className="block text-xs text-gray-400 mt-1">{ajuda}</span>}
    </label>
);

// ---------- botões ----------
const BOTAO = {
    primario: 'bg-indigo-600 text-white hover:bg-indigo-700 border border-indigo-600',
    secundario: 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300',
    perigo: 'bg-white text-red-600 hover:bg-red-50 border border-red-200',
    sucesso: 'bg-green-600 text-white hover:bg-green-700 border border-green-600',
    fantasma: 'bg-transparent text-gray-600 hover:bg-gray-100 border border-transparent',
};
export const Botao = ({ variante = 'secundario', tamanho = 'md', className = '', children, ...props }) => (
    <button
        type="button"
        {...props}
        className={`inline-flex items-center justify-center gap-1.5 rounded-md font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${tamanho === 'sm' ? 'h-7 px-2.5 text-xs' : 'h-9 px-4 text-sm'} ${BOTAO[variante]} ${className}`}
    >
        {children}
    </button>
);

// ---------- campo de busca ----------
export const Busca = ({ valor, onChange, placeholder, className = '' }) => (
    <div className={`relative ${className}`}>
        <IconBusca className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
            type="text"
            value={valor}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="w-full h-9 border border-gray-300 rounded-md pl-9 pr-8 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-300"
        />
        {valor && (
            <button type="button" onClick={() => onChange('')} title="Limpar"
                className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 text-lg leading-none">×</button>
        )}
    </div>
);

// ---------- aviso que some sozinho (substitui os alert de sucesso) ----------
export const Aviso = ({ aviso, onFechar }) => {
    useEffect(() => {
        if (!aviso) return undefined;
        const t = setTimeout(onFechar, aviso.tipo === 'erro' ? 7000 : 3500);
        return () => clearTimeout(t);
    }, [aviso, onFechar]);
    if (!aviso) return null;
    const cor = aviso.tipo === 'erro' ? 'bg-red-50 border-red-200 text-red-700' : 'bg-green-50 border-green-200 text-green-800';
    return (
        <div className={`flex items-start gap-2 border rounded-md px-3 py-2 text-sm ${cor}`}>
            <span className="flex-1">{aviso.texto}</span>
            <button type="button" onClick={onFechar} className="opacity-60 hover:opacity-100 leading-none text-lg">×</button>
        </div>
    );
};

// ---------- avatar com iniciais ----------
const CORES_AVATAR = ['bg-indigo-100 text-indigo-700', 'bg-emerald-100 text-emerald-700', 'bg-amber-100 text-amber-800', 'bg-rose-100 text-rose-700', 'bg-sky-100 text-sky-700', 'bg-violet-100 text-violet-700'];
export const Avatar = ({ nome, className = 'h-9 w-9 text-sm' }) => {
    const partes = String(nome || '?').trim().split(/\s+/);
    const iniciais = ((partes[0] || '')[0] || '?') + ((partes.length > 1 ? partes[partes.length - 1][0] : '') || '');
    const idx = Array.from(String(nome || '')).reduce((a, c) => a + c.charCodeAt(0), 0) % CORES_AVATAR.length;
    return <span className={`inline-flex items-center justify-center rounded-full font-bold flex-shrink-0 uppercase ${CORES_AVATAR[idx]} ${className}`}>{iniciais}</span>;
};

// ---------- estado vazio ----------
export const Vazio = ({ children }) => <div className="px-4 py-10 text-center text-sm text-gray-500">{children}</div>;


// ---------- lista com busca enquanto digita (substitui os <select> de escolha) ----------
// Igual ao campo de empresa da pendência: filtra sem diferenciar maiúsculas nem acentos,
// mostra primeiro as opções que COMEÇAM com o texto, ↑ ↓ navegam, Enter escolhe, Esc fecha.
//   opcoes: [{ valor, rotulo, detalhe? }]   valor: o valor escolhido ('' = nenhum)
//   extra?: texto que aparece logo depois do nome, com a mesma fonte (ex.: celular do usuário)
//   onChange(valor) é chamado ao escolher e com '' ao limpar.
export const BuscaSelect = ({
    opcoes, valor, onChange, placeholder = 'Digite para buscar...', vazio = 'Nada encontrado',
    disabled = false, inputRef, id, className = '', inputClassName = '', maiusculas = true,
}) => {
    const [texto, setTexto] = useState('');
    const [aberto, setAberto] = useState(false);
    const [destaque, setDestaque] = useState(0);
    const listaRef = useRef(null);
    const textoRef = useRef('');
    textoRef.current = texto;

    const selecionada = opcoes.find((o) => o.valor === valor);
    const rotuloSelecionado = selecionada ? selecionada.rotulo : '';

    // mostra o nome da opção escolhida (ou limpa quando o valor é limpo por fora)
    useEffect(() => { setTexto(rotuloSelecionado); }, [valor, rotuloSelecionado]);

    const filtradas = useMemo(() => {
        const t = normalizar(texto);
        if (!t || (selecionada && texto === rotuloSelecionado)) return opcoes;
        const comeca = [];
        const contem = [];
        opcoes.forEach((o) => {
            const n = normalizar(o.rotulo);
            if (n.startsWith(t)) comeca.push(o);
            else if (n.includes(t)) contem.push(o);
        });
        return [...comeca, ...contem];
    }, [opcoes, texto, selecionada, rotuloSelecionado]);

    useEffect(() => { setDestaque(0); }, [texto]);
    useEffect(() => {
        const el = listaRef.current && listaRef.current.children[destaque];
        if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }, [destaque]);

    const escolher = (o) => { setTexto(o.rotulo); setAberto(false); if (o.valor !== valor) onChange(o.valor); };

    // ao sair sem escolher: se o texto bate exatamente com uma opção, escolhe; senão volta ao que estava
    const aoSair = () => setTimeout(() => {
        setAberto(false);
        const atual = textoRef.current;
        if (!atual) return;
        const exata = opcoes.find((o) => normalizar(o.rotulo) === normalizar(atual));
        if (exata) { setTexto(exata.rotulo); if (exata.valor !== valor) onChange(exata.valor); }
        else setTexto(rotuloSelecionado);
    }, 150);

    const destacar = (rotulo) => {
        const t = normalizar(texto);
        const i = t && !(selecionada && texto === rotuloSelecionado) ? normalizar(rotulo).indexOf(t) : -1;
        if (i < 0) return rotulo;
        return <>{rotulo.slice(0, i)}<b className="text-indigo-700">{rotulo.slice(i, i + t.length)}</b>{rotulo.slice(i + t.length)}</>;
    };

    return (
        <div className={`relative ${className}`}>
            <input
                ref={inputRef}
                id={id}
                type="text"
                autoComplete="off"
                value={texto}
                disabled={disabled}
                placeholder={placeholder}
                onChange={(e) => { setTexto(maiusculas ? e.target.value.toUpperCase() : e.target.value); setAberto(true); }}
                onFocus={(e) => { setAberto(true); e.target.select(); }}
                onBlur={aoSair}
                onKeyDown={(e) => {
                    if (e.key === 'ArrowDown') { e.preventDefault(); setAberto(true); setDestaque((i) => Math.min(i + 1, Math.max(0, filtradas.length - 1))); }
                    else if (e.key === 'ArrowUp') { e.preventDefault(); setDestaque((i) => Math.max(i - 1, 0)); }
                    else if (e.key === 'Enter') { if (aberto && filtradas[destaque]) { e.preventDefault(); escolher(filtradas[destaque]); } }
                    else if (e.key === 'Escape') { setAberto(false); setTexto(rotuloSelecionado); }
                }}
                className={`w-full h-9 border rounded-md pl-3 pr-7 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300 disabled:bg-gray-100 disabled:cursor-not-allowed ${maiusculas ? 'uppercase' : ''} ${valor ? 'border-indigo-400 bg-indigo-50' : 'border-gray-300 bg-white'} ${inputClassName}`}
            />
            {texto && !disabled && (
                <button type="button" tabIndex={-1} title="Limpar"
                    onMouseDown={(e) => { e.preventDefault(); setTexto(''); setAberto(true); if (valor) onChange(''); }}
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 text-lg leading-none">×</button>
            )}
            {aberto && !disabled && (
                <ul ref={listaRef} className="absolute z-30 w-full min-w-[12rem] bg-white border border-gray-200 rounded-md shadow-lg mt-1 max-h-60 overflow-y-auto text-sm text-left">
                    {filtradas.length ? filtradas.map((o, i) => (
                        <li key={o.valor}
                            onMouseDown={(ev) => { ev.preventDefault(); escolher(o); }}
                            onMouseEnter={() => setDestaque(i)}
                            className={`px-3 py-1.5 cursor-pointer flex justify-between gap-3 ${i === destaque ? 'bg-indigo-100' : ''} ${o.valor === valor ? 'font-semibold' : ''}`}>
                            <span className="truncate">{destacar(o.rotulo)}{o.extra && <span className="ml-3">{o.extra}</span>}</span>
                            {o.detalhe && <span className="text-gray-400 text-xs flex-shrink-0">{o.detalhe}</span>}
                        </li>
                    )) : <li className="px-3 py-2 text-gray-400">{vazio}</li>}
                </ul>
            )}
        </div>
    );
};
